export default "/_next/static/fonts/tt_norms_pro_black-81cf45b06bacbf4ec3730c365eac61a0.woff";